import { render, staticRenderFns } from "./PopupNotFoundError.vue?vue&type=template&id=73d48d52&scoped=true"
import script from "./PopupNotFoundError.vue?vue&type=script&lang=js"
export * from "./PopupNotFoundError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d48d52",
  null
  
)

export default component.exports